import { Button, DatePicker, Form, Modal } from "antd";
import es_ES from "antd/lib/date-picker/locale/es_ES";
import { useContext, useState } from "react";
import Select from 'react-select';
import { toast, ToastContainer } from "react-toastify";
import { CompanyProfileContext } from "../../../../CustomContext";
import { newInvoiceRequest } from "../../../../lib/newInvoiceRequest";
import InteresByInvoice from "../../mora/InteresByInvoice";

const notifyBottomRight = () => {
  toast.success("✔️ Factura solicitada exitosamente.", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

const ModalGenerateInvoice = ({ showModal, setShowModal, employeeList }) => {
  const { companyProfile } = useContext(CompanyProfileContext);
  const [period, setPeriod] = useState([]);
  const [interestInvoice, setInterestInvoice] = useState(0); // Estado para el interés calculado
  const [tipoAporte, setTipoAporte] = useState({value: 'sindical', label: 'Sindical' }); // tipo de aporte

  const handleSelectChange = (selectedOption) => {
    debugger
    setTipoAporte(selectedOption);
};
  return (
    <>
      <Modal
        width={750}
        closable={false}
        title="Solicitud de factura"
        open={showModal}
        destroyOnClose
        footer={[
          <Button key="1" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>,
          <Button
            key="2"
            type="primary"
            onClick={async () => {
             
              debugger
              await newInvoiceRequest({
                idCompany: companyProfile && companyProfile._id,
                period,
                interestInvoice,// Pasamos el interés calculado a `newInvoiceRequest`
                tipoAporte:tipoAporte.value
              }).then((res) => {
                if (res.status === 200) {
                  setPeriod([]);
                  setShowModal(false);
                  notifyBottomRight();
                }
              });
            }}
          >
            Solicitar
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="Seleccione el período a facturar">
            <DatePicker.RangePicker
              placeholder={["Fecha desde", "Fecha hasta"]}
              locale={es_ES}
              onChange={(v, d) => setPeriod(d)}
            />
            {/* Pasamos `setInterestInvoice` para actualizar el interés en `ModalGenerateInvoice` */}
            {period && period.length === 2 && (
              <InteresByInvoice period={period} setInterestInvoice={setInterestInvoice} />
            )}
          </Form.Item>
          <Form.Item label="Tipo de Aporte a facturar">
            <Select 
                className="custom-react-select"
                options={[
                    { value: 'sindical', label: 'Sindical' },
                    { value: 'formacion', label: 'Por Formacion' }                   
                ]}
                value={tipoAporte}
                onChange={(selectedOption) => handleSelectChange(selectedOption)}
                isSearchable={true}
            />
          </Form.Item>
        </Form>
      </Modal>
      <ToastContainer />
    </>
  );
};

export default ModalGenerateInvoice;
